import React from 'react'
import styled from 'styled-components'
import { graphql, useStaticQuery } from 'gatsby'
import Icon from '../Icon'
import XIcon from '../../../images/x.svg'
import YouTubeIcon from '../../../images/youtube.svg'
import GithubIcon from '../../../images/github.svg'
import RssIcon from '../../../images/rss.svg'

const SocialList = styled.ul`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-left: 3.5rem;

  @media screen and (max-width: 480px) {
    margin-left: 0;
  }

  > li {
    display: inline-block;
    margin-right: 8px;

    a {
      &:hover {
        path,
        circle {
          fill: rgb(var(--tltr-awesome-value));
        }
      }
    }
  }
`

const SocialLinks = () => {
  const data = useStaticQuery(graphql`
    query NavigationSocialQuery {
      site {
        siteMetadata {
          social {
            twitter
            youtube
            github
          }
        }
      }
    }
  `)
  const { twitter, youtube, github } = data.site.siteMetadata.social

  return (
    <SocialList>
      <li>
        <a
          href={`https://www.youtube.com/user/${youtube}`}
          target="_blank"
          rel="noreferrer"
          aria-label="YouTube"
        >
          <Icon>
            <YouTubeIcon />
          </Icon>
        </a>
      </li>
      <li>
        <a
          href={`https://x.com/${twitter}`}
          target="_blank"
          rel="noreferrer"
          aria-label="X"
        >
          <Icon>
            <XIcon />
          </Icon>
        </a>
      </li>
      <li>
        <a
          href={`https://github.com/${github}`}
          target="_blank"
          rel="noreferrer"
          aria-label="GitHub"
        >
          <Icon>
            <GithubIcon />
          </Icon>
        </a>
      </li>
      <li>
        <a href="/rss.xml" target="_blank" rel="noreferrer" aria-label="RSS">
          <Icon>
            <RssIcon />
          </Icon>
        </a>
      </li>
    </SocialList>
  )
}

export default SocialLinks
